module.exports = __webpack_public_path__ + "static/img/NSW-15.48dcd48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-15.jpg
// module id = dd86
// module chunks = 0